<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
    name: 'App',
    methods: {
    }
};
</script>
<style lang="scss">
/*按钮样式*/
.el-button--primary{
    background: rgba(0,0,0,0);
    color: #d9d9d9;
    border: 0;
    .icon {
        fill: #d9d9d9;
    }
}
.el-button--primary:hover {
    color: #FFF;
    background: rgba(0,0,0,0);
    .icon {
        fill: #FFF;
    }
}

.el-button--primary:active {
    background: rgba(0,0,0,0);
    color: #d9d9d9;;
     border: 0;
 }

.el-button--primary:focus {
    background: rgba(0,0,0,0);
    color: #d9d9d9;
    border: 0;
  }

.el-button--success{
    background: #08d13e;
    color: white;
    border: 0;
}
.el-button--danger{
    background: #c90808;
    color: white;
    border: 0;
}

.el-button--warning{
    background: #ef9510;
    color: white;
    border: 0;
}

.el-button--info{
    background: #0074ad;
    color: white;
    border: 0;
}

/*滚动条样式*/
::-webkit-scrollbar {
    width: 4px;
    height: 0;
    background-color: #ebeef5;
}
::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #ccc;
}
::-webkit-scrollbar-track{
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    background: rgba(255, 255, 255, 1);
}


  /*加载样式*/
  .el-loading-mask{
      background-color: rgba(255,255,255,0.7);
  }
/*//设置图标颜色*/
  .el-loading-spinner .path{
      stroke: #2762cb;
  }
/*//设置文字颜色*/
  .el-loading-spinner .el-loading-text{
      color: #2762cb;
  }


.el-select-dropdown {
    border: none;
    color: black;
    /*background-color: rgba(1, 28, 82, 0.8);*/
}

/*//输入框*/
  .el-input__inner{
      color:black;
      /*border-color: white;*/
      /*background-color: rgba(255, 255, 255, 0.8);*/
  }
/*//聚焦时的样式*/
  .el-select .el-input.is-focus .el-input__inner{
      /*border-color: white;*/
      /*background-color: rgba(1, 28, 82, 0.8);*/
      /*color:white;*/
  }
/*//下拉框选中*/
  .el-select-dropdown__item {
      color: black;
      /*background-color: rgba(0,0,0,0.1);*/
  }

  .el-select-dropdown__item:hover{
      color:black;
      background-color: rgba(0,0,0,0.1);
  }


//确认框样式
.confirm {
    border-radius: 5px;
    .el-message-box__btns {
        .el-button:nth-child(1) {
            float:right;
        }
        .el-button:nth-child(2) {
            margin-right:10px;
            color: white;
            background-color:#2d8cf0;
            border-color:#2d8cf0;
        }
    }
}




#app {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}



/* common0.css */
/* CSS Document */
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box
}

*, body {
    padding: 0px;
    margin: 0px;
    /* color: #898989; */
    font-family: "微软雅黑";
    font-size: 16px;
    /* background: #000F2A; */
}

body {
    background-color: #000F2A;
    color: #666;
    font-size: 14px;
}



</style>



// WEBPACK FOOTER //
// src/App.vue